import moment from 'moment';

export default {
  methods: {
    formatAmountNeeded(value, key, item) {
      return Math.max(value, 0).toLocaleString(undefined, {
        minimumFractionDigits: item.base_unit_precision,
        maximumFractionDigits: item.base_unit_precision,
      });
    },
    formatShoppingPlace(value) {
      return this.filterOptions.shopping_places.find((obj) => {
        return obj.value === value;
      }).text;
    },
    formatIngredientCategory(value) {
      return this.filterOptions.ingredient_categories.find((obj) => {
        return obj.value === value;
      }).text;
    },
    formatIngredientPerishable(value) {
      return value ? 'Ja' : 'Nein';
    },
    formatCustomsCategory(value) {
      return this.filterOptions.customs_categories.find((obj) => {
        return obj.value === value;
      }).text;
    },
    formatDate(value, format) {
      return moment(value).format(format);
    },
  },
};
